import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import PatientInsuranceForm from '../components/PatientInsuranceForm';
import { hostTitle } from '../../../config/ui';
import { requestPatientInsurance, uploadPatientInsuranceFiles } from '../../../store/integrations/IntegrationsActions';

class PatientInsuranceEdit extends React.Component {
  
  componentWillMount() {
    this.props.getPatientInsurance({
      tenantId: this.props.tenantId,
    });
  }

  onSubmit = (values) => {
    this.props
      .uploadPatientInsuranceFiles({
        tenantId: this.props.tenantId,
        emailTo: values.email,
        name: values.name
      }, values.files)
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        }
        else {
          toast.success('Athena Patient Insurance Uploaded.');
          hashHistory.push('/athena-patient-insurance/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/athena-patient-insurance/');
  };

  render() {
    const {
      data: { insurance,
        isLoading,
      },
    } = this.props;

    return (
      <div id="content">
        {insurance.id && <Helmet title={`${insurance.id} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Integrations',
            { title: 'Patient Insurance Manager', route: '/athena-patient-insurance' },
            'Add Patient Insurance',
          ]}
          icon="fa fa-fw fa-map"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>{
                insurance.id && `Edit Patient Insurance `}
                {insurance.id && <i>({insurance.id})</i>}
                {!insurance.id && `Add Patient Insurance `}
              </h2>
            </header>
            <div>
              <div className="widget-body">
                {insurance.id && (
                  <PatientInsuranceForm
                  isLoading={isLoading}
                  onSubmit={this.onSubmit}
                  deleteFile={this.deleteFile}
                  onCancel={this.onCancel}
                  />
                )}
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.integrationsmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getPatientInsurance: (params) => dispatch(requestPatientInsurance(params)),
    uploadPatientInsuranceFiles: (params, files) => dispatch(uploadPatientInsuranceFiles(params, files)),
  }),
)(PatientInsuranceEdit);



// WEBPACK FOOTER //
// ./src/routes/integrations/containers/PatientInsuranceEdit.js